import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { MoviesList } from '../pages/movies/moviesList/MoviesList'
import { AddMovies } from '../pages/movies/addMovies/AddMovies'
import { Minuta } from '../pages/demoMinutas/Minuta'
import { CreateContract } from '../pages/createContract/CreateContract'
import { MinutaC } from '../pages/demoMinutas/minutaC/MinutaC'
import { Grilla1 } from '../pages/minutas/grillas/Grilla1'
import { MinutaVertical } from '../pages/minutas/minutaVertical/MinutaVertical'
import { MinutaHorizontal } from '../pages/minutas/minutaHorizontal/MinutaHorizontal'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import store from '../../setup/redux/Store'
import * as _redux from '../../setup'
import { Maintainer } from '../pages/administracion/maintainer/Maintainer'
import { ErrorsPage } from '../modules/errors/ErrorsPage'

import { SamlWrapper } from 'app/pages/saml/saml'
import { BulkLoad } from 'app/pages/bulkLoad/bulkLoad'
import { ImportPage } from 'app/pages/support/import-excel/import-excel.page'

const PrivateRoutes = () => {
  const dispatch = useDispatch()
  _redux.SetupAxios(axios, store, dispatch)
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const MinutasPage = lazy(() => import('../pages/minutas/MinutasPage'))
  const PlantillasPage = lazy(() => import('../pages/plantillas/PlantillasPage'))
  const AdministracionPage = lazy(() => import('../pages/administracion/AdministracionPage'))
  const ManteinerPage = lazy(() => import('../pages/administracion/ManteinerPage'))
  const InformesPage = lazy(() => import('../pages/informes/InformesPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        <Route path='MoviesList' element={<MoviesList />} />
        <Route path='addMovie' element={<AddMovies />} />
        <Route path='minuta' element={<Minuta />} />
        <Route path='minutaC' element={<MinutaC />} />
        <Route path='Maintainer' element={<Maintainer />} />
        <Route path='BulkLoad' element={<BulkLoad />} />
        <Route path='grilla1' element={<Grilla1 />} />
        <Route path='minutaVertical' element={<MinutaVertical />} />
        <Route path='minutaHorizontal' element={<MinutaHorizontal />} />
        <Route path='createContract' element={<CreateContract />} />
        <Route path='saml' element={<SamlWrapper />} />

        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='/minutas/*'
          element={
            <SuspensedView>
              <MinutasPage />
            </SuspensedView>
          }
        />
        <Route
          path='/plantillas/*'
          element={
            <SuspensedView>
              <PlantillasPage />
            </SuspensedView>
          }
        />
        <Route
          path='/support/*'
          element={
            <SuspensedView>
              <ImportPage />
            </SuspensedView>
          }
        />
        <Route
          path='/administracion/*'
          element={
            <SuspensedView>
              <AdministracionPage />
            </SuspensedView>
          }
        />
        <Route
          path='/mantenedores/*'
          element={
            <SuspensedView>
              <ManteinerPage />
            </SuspensedView>
          }
        />
        <Route
          path='/informes/*'
          element={
            <SuspensedView>
              <InformesPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<ErrorsPage />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
